import React, {Component} from 'react'
import {AvForm, AvInput} from 'availity-reactstrap-validation'
import LoadingButton from "../LoadingButton"
import moment from 'moment'
import PropTypes from 'prop-types'

export class ProjectWriteoffInput extends Component{

    constructor(props){
        super(props)

        this.state = {
            id: props.id || null,
            project_activity_budget_id: props.project_activity_budget_id || '',
            description: props.description || '',
            amount: props.amount || '',
            written_off_at: moment(props.written_off_at).format('YYYY-MM-DD') || ''

        }
    }

    render(){

        const {onCancel, onAdd, loading, budgets} = this.props
        const {description, project_activity_budget_id, amount, written_off_at} = this.state

        return (
            <AvForm
                ref={ref => this.form = ref}
                className="d-flex flex-row" style={{flex: '1'}}
                onValidSubmit={() => {
                    if(onAdd) onAdd(this.state)
                }}
            >
                <div className="d-flex mr-2" style={{flex: '1'}}>
                    <AvInput
                        required
                        name="project_activity_budget_id"
                        type="select"
                        className="form-control-sm"
                        value={project_activity_budget_id}
                        onChange={(evt) => this.setState({project_activity_budget_id: evt.target.value})}
                    >
                        <option value="">---Select Budget---</option>
                        {budgets && budgets.map(budget => <option value={budget.id}>{budget.budget_label}</option>)}
                    </AvInput>
                </div>
                <div className="d-flex mr-2" style={{flex: '1'}}>
                    <AvInput
                        required
                        name="description"
                        type="text"
                        className="form-control-sm"
                        placeholder="Description"
                        value={description}
                        onChange={(evt) => this.setState({description: evt.target.value})}
                    />
                </div>
                <div className="d-flex mr-2" style={{flex: '1'}}>
                    <AvInput
                        required
                        name="amount"
                        type="number"
                        className="form-control-sm"
                        placeholder="Amount"
                        value={amount}
                        onChange={(evt) => this.setState({amount: evt.target.value})}
                    />
                </div>
                <div className="d-flex mr-2" style={{flex: '1'}}>
                    <AvInput
                        required
                        name="written_off_at"
                        type="date"
                        className="form-control-sm"
                        placeholder="Date of Write Off"
                        value={written_off_at}
                        onChange={(evt) => this.setState({written_off_at: evt.target.value})}
                    />
                </div>
                <div className="d-flex mr-1">
                    <LoadingButton
                        size="sm"
                        color="secondary"
                        className="square-btn"
                        icon="times"
                        loading={false}
                        onClick={() => {
                            if (onCancel) onCancel()
                        }}
                    />
                </div>
                <LoadingButton
                    size="sm"
                    color="success"
                    className="square-btn"
                    icon="save"
                    loading={loading}
                />
            </AvForm>
        )
    }

}

ProjectWriteoffInput.propTypes = {
    budgets: PropTypes.array,
    id: PropTypes.number,
    project_activity_budget_id: PropTypes.number,
    description: PropTypes.string,
    amount: PropTypes.number,
    written_off_at: PropTypes.string
}